import { VehicleStatus } from "../logic/api";


export function getVehicleStatusKey(statusId: VehicleStatus) {
            switch (statusId) {
            case VehicleStatus.NotCheckedIn:
                return 'booking.vehicleStatus.notCheckedIn';
            case VehicleStatus.PreCheckIn:
                return 'booking.vehicleStatus.preCheckIn';
            case VehicleStatus.CheckedIn:
                return 'booking.vehicleStatus.checkedIn';
            case VehicleStatus.CheckedOut:
                return 'booking.vehicleStatus.checkedOut';
            default:
                return 'booking.vehicleStatus.unknown';
        }
}